import { useId, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { iniciarSesion } from './autenticacion';
import { mensajeDeLogin } from './mensajes';

/**
 * El formulario de email + contraseña. Lo usan **la pantalla de login y el
 * diálogo de reingreso**: es el mismo acto y tiene que comportarse igual en los
 * dos lados, sobre todo en lo que muestra cuando falla.
 *
 * Detalles que no son casuales:
 *
 * - El `<form>` hace `preventDefault` y postea con `fetch`. Si el navegador
 *   enviara el formulario de verdad, el email y la contraseña podrían terminar
 *   en la barra de direcciones y en el historial.
 * - El error se saca de {@link mensajeDeLogin}, que no revela si la cuenta
 *   existe.
 * - No hay `autoComplete="off"`: el gestor de contraseñas del navegador es
 *   parte de la defensa, no un estorbo.
 */
export function FormularioDeLogin({
  alEntrar,
  textoDelBoton = 'Entrar',
  emailInicial = '',
}: {
  /** Se llama cuando la sesión quedó abierta. */
  alEntrar?: () => void;
  textoDelBoton?: string;
  /** Para el reingreso: ya sabemos de quién es la sesión que se cayó. */
  emailInicial?: string;
}) {
  const idEmail = useId();
  const idPassword = useId();
  const [email, setEmail] = useState(emailInicial);
  const [password, setPassword] = useState('');

  const entrada = useMutation({
    mutationFn: () => iniciarSesion({ email, password }),
    onSuccess: () => {
      // La contraseña no se queda en el estado de React más de lo necesario.
      setPassword('');
      alEntrar?.();
    },
  });

  return (
    <form
      onSubmit={(evento) => {
        evento.preventDefault();
        entrada.mutate();
      }}
      noValidate
    >
      <p>
        <label htmlFor={idEmail}>Email</label>
        <br />
        <input
          id={idEmail}
          name="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(evento) => setEmail(evento.target.value)}
          required
        />
      </p>
      <p>
        <label htmlFor={idPassword}>Contraseña</label>
        <br />
        <input
          id={idPassword}
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(evento) => setPassword(evento.target.value)}
          required
        />
      </p>
      {entrada.isError ? (
        // `role="alert"` para que un lector de pantalla lo anuncie sin que la
        // persona tenga que ir a buscarlo.
        <p role="alert" className="error">
          {mensajeDeLogin(entrada.error)}
        </p>
      ) : null}
      <button type="submit" disabled={entrada.isPending}>
        {entrada.isPending ? 'Entrando…' : textoDelBoton}
      </button>
    </form>
  );
}
